export const state = () => (require('@pleinair/bigcolony-vue/store/_state')(require('../app.json')))
export const mutations = require('@pleinair/bigcolony-vue/store/_mutations')
export const actions = require('@pleinair/bigcolony-vue/store/_actions')
